import styled from 'styled-components'
import { FilterPillContent } from '@/features/shop/components/ProductFilter/FilterOptions/FilterPillContent'
import { RetailerFilterSection } from '@/features/shop/components/ProductFilter/RetailerFilterSection'
import { SEARCH_FILTER_TYPE } from '@/features/shared/constants/global'
import { Image } from '@/features/shared/elements/Image/NextImage'
import { FilterScrollWrapper } from '@/features/shop/components/ProductFilter/FilterScrollWrapper'
import { useMarketingZip } from '@/features/shop/components/UngatedCategoryPage/hooks'
import { findActiveStoreFilters } from '@/features/shop/services/Search/utils'
import { useQueryShoppingStores } from '@/features/shop/services/ShoppingStore/queries'
import { useValidSearchParams } from '@/features/shared/hooks/search'
import { Box, Row } from '@shipt/design-system-layouts'
import { useQueryUniversalSearch } from '@/features/shop/services/UniversalCategories/queries'

const { STORE } = SEARCH_FILTER_TYPE
type Props = { index: number }

export const RetailerFilterOption = ({ index }: Props) => {
  // prefetch the available stores without any store contexts
  // this is to get the list of all stores available in the user's zip
  useQueryUniversalSearch({ contexts: undefined })
  const searchParams = useValidSearchParams()
  const zip = useMarketingZip()
  const storesInZip = useQueryShoppingStores({ zip }).data?.delivery_stores ?? []
  const storeFilters = findActiveStoreFilters(storesInZip, searchParams)
  const filterName = storeFilters[0]?.name ?? `Retailers in ${zip}`
  const renderImg = () => (
    <Row align="center">
      {storeFilters.slice(0, 3).map((store) => (
        <FilterImage
          key={store.id}
          src={store.circular_image}
          alt={`${store.name} logo`}
          height={16}
          width={16}
        />
      ))}
    </Row>
  )

  return (
    <FilterScrollWrapper facet={STORE} index={index}>
      <Box paddingLeft={0}>
        <FilterPillContent name={filterName} filterType={STORE} renderImg={renderImg}>
          <RetailerFilterSection zip={zip} />
        </FilterPillContent>
      </Box>
    </FilterScrollWrapper>
  )
}

const FilterImage = styled(Image)`
  min-width: 1rem;
  min-height: 1rem;

  &:not(:first-child) {
    margin-left: -0.25rem;
  }
`
